import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M15.874 4.606a.5.5 0 0 1 0 .708L9.186 12l6.687 6.686a.5.5 0 1 1-.708.708l-7.04-7.04a.5.5 0 0 1 0-.707l7.04-7.04a.5.5 0 0 1 .707 0" />
  </svg>
);
export default SvgChevronLeft;
